import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

const DEFAULT_VOLUME_PERCENTAGE = 75;

@Component({
  selector: 'edit-alert-volume',
  templateUrl: './edit-alert-volume.component.html',
  styleUrls: ['./edit-alert-volume.component.scss'],
  standalone: false,
})
export class EditAlertVolumeComponent {
  model: any;
  volumePercentage: number = DEFAULT_VOLUME_PERCENTAGE;

  constructor(
    public dialogRef: MatDialogRef<EditAlertVolumeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.model = { ...data };
    this.ensureVolumeControlSettings();
    // Initialize volume percentage from the model if available
    if (
      this.model.settings &&
      this.model.settings.volumePercentage !== undefined
    ) {
      this.volumePercentage = this.model.settings.volumePercentage;
    }
  }

  private ensureVolumeControlSettings() {
    if (!this.model.settings) {
      this.model.settings = {};
    }

    if (this.model.settings.volumeControlSupported === undefined) {
      this.model.settings.volumeControlSupported = false;
    }
    if (this.model.settings.volumePercentage === undefined) {
      this.model.settings.volumePercentage = DEFAULT_VOLUME_PERCENTAGE;
    }
  }

  onVolumeChange(value: number) {
    this.volumePercentage = value;
    if (!this.model.settings) {
      this.model.settings = {};
    }
    this.model.settings.volumePercentage = value;
  }

  onVolumeInputChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const volume = Number.parseInt(target.value, 10);

    if (!Number.isNaN(volume)) {
      const clampedVolume = Math.max(0, Math.min(100, volume));
      this.volumePercentage = clampedVolume;
      if (!this.model.settings) {
        this.model.settings = {};
      }
      this.model.settings.volumePercentage = clampedVolume;
    }
  }

  onVolumeControlToggle(enabled: boolean) {
    // Initialize volume control settings if they don't exist
    if (!this.model.settings) {
      this.model.settings = {};
    }

    // Update volume control support (ngModel already handled the toggle)
    this.model.settings.volumeControlSupported = enabled;

    if (enabled) {
      // If enabling volume control, set default volume if not already set
      if (
        this.model.settings.volumePercentage === undefined ||
        this.model.settings.volumePercentage === 0
      ) {
        this.model.settings.volumePercentage = DEFAULT_VOLUME_PERCENTAGE;
        this.volumePercentage = DEFAULT_VOLUME_PERCENTAGE;
      } else {
        // Sync the component property with the model if volume is already set
        this.volumePercentage = this.model.settings.volumePercentage;
      }
      return;
    }

    // If disabling volume control, reset volume percentage
    this.model.settings.volumePercentage = 0;
    this.volumePercentage = 0;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onApply() {
    this.dialogRef.close(this.model);
  }
}
